import {Dimensions, StyleSheet, ViewStyle} from 'react-native';

const {width} = Dimensions.get('window');

const Colors = {
  mBackColor: '#efefef',
  mBorderColor: '#efefef',
  white: '#FFFFFF',
  shadowColor: '#A69E9E',
};

const Metrics = {
  containerWidth: width - 30,
  switchWidth: width / 2.7,
};

export default StyleSheet.create({
  formContainer: {
    padding: 8,
    flex: 1,
  },
  formContainContract: {
    padding: 30,
  },
  displayHorizontal: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexWrap: 'wrap',
  },
  containers: {
    width: Metrics.containerWidth,
    height: 55,
    flexDirection: 'row',
    backgroundColor: Colors.mBackColor,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: Colors.mBorderColor,
    borderRadius: 27.5,
  },
  button: {
    margin: 15,
    color: '#fff',
    padding: 10,
    paddingLeft: 30,
    paddingRight: 30,
    backgroundColor: '#69bbea',
  },
  container: {
    marginVertical: 8,
  },
  wrapperInputPosition: {
    flexBasis: '30%',
    flexDirection: 'row',
    alignItems: 'flex-start',
    fontWeight: 700,
    fontSize: 14,
    marginTop: 20,
    zIndex: 1,
    width: '100%',
  },
  semiFlex: {
    flex: 1,
    flexGrow: 0,
    flexBasis: '50%',
    maxWidth: '80%',
    order: 0,
  } as ViewStyle,
  semiFlexOne: {
    flex: 0,
    flexGrow: 0,
    flexBasis: '50%',
    maxWidth: '50%',
    order: 2,
  } as ViewStyle,
  semiFlexTwo: {
    flex: 0,
    flexGrow: 0,
    flexBasis: '100%',
    maxWidth: '100%',
    order: 1,
  } as ViewStyle,
  input: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 5,
    paddingVertical: 5,
    paddingLeft: 5,
    fontSize: 16,
    height: 40,
    color: '#c0cbd3',
  },
  info: {
    backgroundColor: 'black',
    width: 20,
    borderRadius: 15,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  colorWhite: {
    zIndex: 9999,
    color: 'white',
  },
  App: {
    textAlign: 'left',
    paddingTop: 10,
  },
  label: {
    marginRight: 20,
    marginLeft: 20,
    marginTop: 10,
    marginBottom: 10,
    fontSize: 16,
    fontWeight: 'normal',
    color: 'black',
  },
  bold: {
    fontWeight: 'bold',
  },
  textError: {
    color: '#f00',
    fontSize: 14,
  },
  item: {
    marginBottom: 14,
  },
  btnAnnuler: {},
  btnValider: {},
  btnPayment: {
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    paddingBottom: 10,
  },
  contratRattacheWrapper: {
    marginVertical: 20,
    marginHorizontal: 10,
    padding: 17,
    backgroundColor: 'white',
    borderRadius: 20,
    alignItems: 'flex-start',
    minWidth: 300,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  contratRattacheModal: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, .8)',
  },
  codeImpression: {
    fontWeight: 700,
    fontSize: 16,
  },
  btnCotisation: {
    fontWeight: 700,
    fontSize: 16,
    marginHorizontal: 8,
  },
});
